module.exports = __webpack_public_path__ + "media/images/icons/flags/PR-1ba0a951aee08767f5c611ed3e29dd4b.svg";